import { VApplication } from "../../../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { UsersListPageService } from "../../../../../services";

const MODULE_NAME = "profile.machines.states.resetPassword";
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.UsersListPageService") as UsersListPageService;
};

export const reInviteUser = async (context: any, event: any) => {
  const currentState = "RE_INVITE";
  const method = "reInvite";

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, "context: ", context, "event: ", event);
      const srv = getSrv();
      const content = await srv.reInviteUser(event?.payload);
      if (content) {
        return resolve({
          key: "RE_INVITE_SUCCESS",
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = "Reset password failed";
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: "RE_INVITE_FAILED",
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: "RE_INVITE_FAILED",
        value: err?.message,
      });
    }
  });
};
